var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e97a95d8aa5a68dc28758f3d9624c39b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 12,
    height: 12,
    rx: 3,
    fill: "#c80a0a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M101.235,102.853A1.862,1.862,0,0,0,99.9,102.5a8.585,8.585,0,0,0-1.261.119,6,6,0,0,1-1.237-1.641,6.653,6.653,0,0,0,.4-1.927c0-.4-.143-1.047-.714-1.047a.491.491,0,0,0-.4.238A3.134,3.134,0,0,0,97,100.617a21.361,21.361,0,0,1-1.189,2.783c-1.261.523-2.093,1.094-2.165,1.546-.048.214.1.571.595.571.737,0,1.546-1.07,2.165-2.165a14.892,14.892,0,0,1,2.188-.571,3.212,3.212,0,0,0,2.07.9C101.425,103.685,101.5,103.138,101.235,102.853ZM96.81,98.309c.19-.285.618-.19.618.381a6.058,6.058,0,0,1-.357,1.713A2.836,2.836,0,0,1,96.81,98.309Zm-3.021,6.661c.071-.381.785-.9,1.9-1.356-.618,1.047-1.237,1.713-1.618,1.713A.291.291,0,0,1,93.789,104.97Zm4.686-2.331a13.655,13.655,0,0,0-1.974.523,10.776,10.776,0,0,0,.856-2A7.778,7.778,0,0,0,98.475,102.639Zm.309.1a5.967,5.967,0,0,1,1.689-.048c.69.143.452.975-.309.785A3.356,3.356,0,0,1,98.784,102.734Z",
    transform: "translate(-91.41 -95.669)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdf);
export default __webpack_public_path__ + "static/media/updf.c8dfbad4abb95b0377aae7aa25493a2f.svg";
export { ForwardRef as ReactComponent };